import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import { Box, Button, Stack, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAppDispatch } from '@/redux/hooks'
import { MediaDetailsContent } from './Content'
import type { ReturnSource } from './helpers/types'
import { handleReturn } from './helpers/utils'
import { useGetSingleMedia } from './hooks/useGetSingleMedia'

export const MediaDetailsPage = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { searchResultItem, url, request } = useGetSingleMedia()

  const isReady = !!searchResultItem && !!url

  const from = (location.state as { from?: ReturnSource } | null)?.from
  const returnTo: ReturnSource = from ?? '/search'
  const returnLabel =
    returnTo === '/mediamanagement'
      ? 'Return to Media Management'
      : 'Return to Search'

  if (!isReady) return null

  return (
    <Stack spacing={2}>
      <Box>
        <Button
          variant="text"
          startIcon={<KeyboardArrowLeftIcon />}
          onClick={() => handleReturn(dispatch, navigate, returnTo)}
        >
          {returnLabel}
        </Button>
      </Box>

      {request.isError ? (
        <Typography>Access Denied</Typography>
      ) : (
        <MediaDetailsContent
          openDrawer={false}
          searchResultItem={searchResultItem}
          url={url}
        />
      )}
    </Stack>
  )
}
